<template>
  <b-modal
    id="appointment-modal" :visible="shallShowModal" centered
    footer-class="d-flex justify-content-between"
    body-class="px-2" size="lg" no-close-on-backdrop static
    @change="(val) => $emit('update:shall-show-modal', val)"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <h5 class="modal-title"> 推介客户单详情 </h5>
      <div class="modal-actions">
        <feather-icon icon="XIcon" class="ml-1 cursor-pointer" @click="$emit('update:shall-show-modal', false)" />
      </div>
    </template>

    <!-- Modal Footer -->
    <template #modal-footer>
      <b-button variant="outline-secondary" class="cursor-pointer ml-0" @click="$emit('update:shall-show-modal', false)"> 取消 </b-button>
      <b-button v-if="formUpdate.status === 2" v-ripple.400="'rgba(113, 102, 240, 0.15)'" @click="verifyEvent"
        variant="primary" class="mb-1 mb-sm-0"> 审核 </b-button>
      <b-button v-else v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary"
      class="mb-1 mb-sm-0" @click="$emit('update:shall-show-modal', false)"> 确定 </b-button>
    </template>

    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="6">
            <b-form-group label="推介单号" label-for="orderSn" label-cols="auto">
              <validation-provider name="推介单号" #default="{ errors }" rules="required">
                <b-form-input
                  id="orderSn" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.orderSn" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="客户联系人" label-for="contactsName" label-cols="auto">
              <validation-provider name="客户联系人" #default="{ errors }" rules="required">
                <b-form-input
                  id="contactsName" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.contactsName" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="到访项目" label-for="projectName" label-cols="auto">
              <validation-provider name="到访项目" #default="{ errors }" rules="required">
                <b-form-input
                  id="projectName" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.projectName" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="客户职位" label-for="contactsPosition" label-cols="auto">
              <validation-provider name="客户职位" #default="{ errors }" rules="required">
                <b-form-input
                  id="contactsPosition" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.contactsPosition" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="客户行业" label-for="customerIndustry" label-cols="auto">
              <validation-provider name="客户行业" #default="{ errors }" rules="required">
                <b-form-input
                  id="customerIndustry" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.customerIndustry" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="联系方式" label-for="contactsPhone" label-cols="auto">
              <validation-provider name="联系方式" #default="{ errors }" rules="required">
                <b-form-input
                  id="contactsPhone" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.contactsPhone" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="客户名称" label-for="customerName" label-cols="auto">
              <validation-provider name="客户名称" #default="{ errors }" rules="required">
                <b-form-input
                  id="customerName" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.customerName" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="推介时间" label-for="recommendTime" label-cols="auto">
              <validation-provider name="推介时间" #default="{ errors }" rules="required">
                <b-form-input
                  id="recommendTime" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.recommendTime" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="意向面积" label-for="needArea" label-cols="auto">
              <validation-provider name="意向面积" #default="{ errors }" rules="required">
                <b-form-input
                  id="needArea" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.needArea" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="预约起租" label-for="rentDate" label-cols="auto">
              <validation-provider name="预约起租" #default="{ errors }" rules="required">
                <b-form-input
                  id="rentDate" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.rentDate" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="预约单号" label-for="subscribeOrderSn" label-cols="auto">
              <validation-provider name="预约单号" #default="{ errors }" rules="required">
                <b-form-input
                  id="subscribeOrderSn" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.subscribeOrderSn" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="经纪姓名" label-for="brokerName" label-cols="auto">
              <validation-provider name="经纪姓名" #default="{ errors }" rules="required">
                <b-form-input
                  id="brokerName" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.brokerName" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="现办公地址" label-for="officeAddress" label-cols="auto">
              <validation-provider name="现办公地址" #default="{ errors }" rules="required">
                <b-form-input
                  id="officeAddress" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.officeAddress" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="实际到访" label-for="realArrivalTime" label-cols="auto">
              <validation-provider name="实际到访" #default="{ errors }" rules="required">
                <b-form-input
                  id="realArrivalTime" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.realArrivalTime" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="单据时间" label-for="createdAt" label-cols="auto">
              <validation-provider name="单据时间" #default="{ errors }" rules="required">
                <b-form-input
                  id="createdAt" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.createdAt" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="审核备注" label-for="verifyRemark" label-cols="auto">
              <b-form-textarea id="verifyRemark" disabled v-model="formUpdate.verifyRemark" rows="2" />
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="审核人员" label-for="verifyAdminUserName" label-cols="auto">
              <validation-provider name="审核人员" #default="{ errors }" rules="required">
                <b-form-input
                  id="verifyAdminUserName" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.verifyAdminUserName" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <b-form-group label="审核时间" label-for="verifyTime" label-cols="auto">
              <validation-provider name="审核时间" #default="{ errors }" rules="required">
                <b-form-input
                  id="verifyTime" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.verifyTime" disabled
                  trim
                />
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- status -->
          <b-col cols="3">
            <b-form-group label="单据状态" label-for="status" label-cols="auto">
              <div class="h-100 d-flex align-items-center">
                <b-badge pill v-if="formUpdate.status === -1" class="px-1 py-50" variant="light-danger"> 已禁用 </b-badge>
                <b-badge pill v-else-if="formUpdate.status === 1" class="px-1 py-50" variant="light-secondary"> 草稿中 </b-badge>
                <b-badge pill v-else-if="formUpdate.status === 2" class="px-1 py-50" variant="light-info"> 待审核 </b-badge>
                <b-badge pill v-else-if="formUpdate.status === 3" class="px-1 py-50" variant="light-warning"> 已驳回 </b-badge>
                <b-badge pill v-else-if="formUpdate.status === 4" class="px-1 py-50" variant="light-success"> 已通过 </b-badge>
                <b-badge pill v-else-if="formUpdate.status === 5" class="px-1 py-50" variant="light-primary"> 已生单 </b-badge>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-form-group label="营业执照" label-for="companyCard" label-cols="auto">
              <viewer :images="[formUpdate.companyCard]">
                <b-img :src="formUpdate.companyCard" class="d-inline-block ml-1 form-image-size" />
              </viewer>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label="附件信息" label-for="attachments" label-cols="auto">
              <validation-provider name="附件信息" #default="{ errors }" rules="required">
                <!-- <b-form-input
                  id="attachments" :state="errors.length > 0 ? false:null"
                  v-model="formUpdate.attachments" disabled
                  trim
                /> -->
                  <viewer :images="formUpdate.attachments">
                    <b-img v-for="(item,index) in formUpdate.attachments" :key="index" :src="item" class="d-inline-block ml-1 form-image-size" />
                  </viewer>
                <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import vSelect from 'vue-select'
import { ref, watch } from '@vue/composition-api'

import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,

    formValidation,
    ValidationProvider,
    ValidationObserver,
    ToastificationContent,
  },
  model: {
    prop: 'shallShowModal',
    event: 'update:shall-show-modal',
  },
  props: {
    shallShowModal: {
      type: Boolean,
      required: true,
    },

    formUpdate: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    /* 必要组件加载区域 */

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */

    // 表单验证dom对象
    const refFormObserver = ref(null)
    
    /* 接口调用区域 */

    /* 组件内部逻辑处理，生命周期问题处理区域 */

    const verifyEvent = () => { emit('verify-event', props.formUpdate.id, props.formUpdate.realArrivalTime) }

    return {
      // formData,
      refFormObserver,
      // resetFormData,
      verifyEvent,
      required,
    }
  },
}
</script>
